import React, { useState, useEffect } from "react";
import { Spin, Typography, Card, Alert } from "antd";
import { API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const { Title } = Typography;

const PublicContentPage = ({ slug, title }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}api/v1/public/content?slug=${slug}`,
        );
        const data = await response.json();

        if (data.status === true && data.data) {
          setContent(data.data.content);
        } else {
          setError(data.message || "Content not found");
        }
      } catch (err) {
        console.error("Error fetching public content:", err);
        setError("Failed to load content. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [slug]);

  if (loading)
    return (
      <Spin size="large" style={{ display: "block", margin: "50px auto" }} />
    );
  if (error)
    return (
      <Alert message={error} type="error" showIcon style={{ margin: 20 }} />
    );

  return (
    <Card style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
      <Title level={2}>{title}</Title>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Card>
  );
};

export default PublicContentPage;
